module.exports = __webpack_public_path__ + "static/media/momentum-light.ab3d155d.png";